
function taskDetails(state = { task : {} , extra: [] , definedTypes: [] , status: [] ,defined: [] , result: {} , modal_one : false , modal_four : false ,
          modal_three: false, modal_two: false , refers : [] , definedCost: 0 , usedPartCost : 0, transport: {} , transportCost : 0 }, action) {
  
    switch (action.type) {
      case "GET_DEFINED_SERVICE_TYPES":
        return {
          ...state,
          definedTypes: action.data
        };
      
      case "GET_DEFINED_SERVICE":
        return {
          ...state,
          defined: action.data
        };
      case "GET_REFERALS":
        return {
          ...state,
          refers: action.data
        };
      case "GET_EXTRA_SERVICE":
        return {
          ...state,
          extra: action.data
        };
      case "CHANGE_TRANSPORT":
        return {
          ...state,
          transport: action.data
        };
        case "GET_TRANSPORT_COST":
          return {
            ...state,
            transportCost: action.data
          };

          case "GET_USEDPART_COST":
            return {
              ...state,
              usedPartCost: action.data
            };
          
          case "GET_DEFINED_COST":
            return {
              ...state,
              definedCost: action.data
            };
    
          
      case "GET_TASKS_DETAILS":
        return {
          ...state,
          task: action.data
        };

     case "GET_TASKS_STATUS":
        return {
          ...state,
          status: action.data
        };
          
      case "GET_TASKS_EXTRA":
        return {
          ...state,
          extra: action.data
        };
          
        
      case "SAVE_PRICE":
        return {
          ...state,
          result: action.data
        };

        case "IS_OPEN_MODAL_ONE":
          return {
            ...state,
            modal_one: action.data
          };

          case "IS_OPEN_MODAL_TWO":
            return {
              ...state,
              modal_two: action.data
            };

          case "IS_OPEN_MODAL_THREE":
              return {
                ...state,
                modal_three: action.data
              };
          case "IS_OPEN_MODAL_FOUR":
                return {
                  ...state,
                  modal_four: action.data
                };
          
      default:
        return state;
    }
  }
  
  export default taskDetails;